export enum PropertyStatus {
  NUOVO = 'NUOVO',
  ABITABILE = 'ABITABILE',
  DA_RISTRUTTURARE = 'DA_RISTRUTTURARE',
  IN_COSTRUZIONE = 'IN_COSTRUZIONE',
  RISTRUTTURATO = 'RISTRUTTURATO',
}
